const SensorKindConsts =
{
    getKind(index: number){
      switch (index)  {
          case 1: return "水位";
          case 2: return "気象";
          case 3: return "騒音振動";
          case 0: return "すべて";
      }
    },
    kinds: [
        {
            "index": 3,
            "name": "騒音振動"
        },
        {
            "index": 2,
            "name": "気象"
        },
        {
            "index": 1,
            "name": "水位"
        }
    ],
};
export default SensorKindConsts;
